import { cn } from '@/app/utils';

export interface TestimonialAuthor {
  name: string;
  /** 职位（如 Marketing Lead / 短片导演）。 */
  role: string;
  avatar: string;
}

export interface TestimonialCardProps {
  author: TestimonialAuthor;
  text: string;
  href?: string;
  className?: string;
}

/**
 * 证言卡片：引言在上，作者信息在下（头像在姓名左侧）。
 *
 * 用普通圆角 <img> 而非 radix-avatar：一个小圆头像不值得引入新依赖 + 过审批 + 改 lockfile。
 */
export function TestimonialCard({ author, text, href, className }: TestimonialCardProps) {
  const Card = href ? 'a' : 'div';

  return (
    <Card
      {...(href ? { href, target: '_blank', rel: 'noopener noreferrer' } : {})}
      className={cn(
        'block w-full overflow-hidden rounded-[20px] text-start',
        'border-white/[0.08] border-t bg-system-white08 p-8',
        'transition-colors duration-300 hover:bg-system-white12',
        className,
      )}
    >
      <p className="text-[16px] text-system-white48 leading-[160%]">{text}</p>
      {/* 作者信息：头像在姓名左侧 */}
      <div className="mt-5 flex items-center gap-3">
        <img
          src={author.avatar}
          alt={author.name}
          loading="lazy"
          decoding="async"
          width={40}
          height={40}
          className="size-10 shrink-0 rounded-full object-cover ring-1 ring-white/20"
        />
        <div className="flex flex-col">
          <span className="font-semibold text-[15px] text-white leading-tight">{author.name}</span>
          <span className="mt-1 text-[13px] text-system-white48 leading-tight">{author.role}</span>
        </div>
      </div>
    </Card>
  );
}
